import { useMutation, gql } from '@apollo/client'

interface Data {
  updatePartRequest: boolean
}

interface Form {
  partRequestId: string
  mpn: string
  description: string
  quantity: number | null
  rfqQuantity?: number | null
  externalId?: string | null
  taskNumber?: string | null
  suggestion?: boolean | null
}

const mutation = gql`
  mutation UpdatePartRequest(
    $partRequestId: ID!
    $mpn: String!
    $description: String!
    $quantity: Int!
    $rfqQuantity: Int
    $externalId: String
    $taskNumber: String
    $suggestion: Boolean
  ) {
    updatePartRequest(
      partRequestId: $partRequestId
      mpn: $mpn
      description: $description
      quantity: $quantity
      rfqQuantity: $rfqQuantity
      externalId: $externalId
      taskNumber: $taskNumber
      suggestion: $suggestion
    )
  }
`

const useUpdatePartRequest = () => {
  const [mutate] = useMutation<Data, Form>(mutation)
  return (variables: Form) => mutate({ variables })
}

export default useUpdatePartRequest
